module.exports = __webpack_public_path__ + "img/2W.2.32b9cdaf.jpg";